(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nxt-shop-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nxt-home-products')) {
  customElements.define('nxt-home-products', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      const tabList = this.querySelector('[data-nxh-tabs]');
      const tabs = Array.from(this.querySelectorAll('[data-nxh-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-nxh-panel]'));
      if (!tabList || !tabs.length || tabs.length !== panels.length) return;
      const select = (index, focus = false) => {
        tabs.forEach((tab, current) => {
          const active = current === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[current].hidden = !active;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + tabs.length) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
        });
      });
      select(0);
      this.setAttribute('data-ready', '');
      tabList.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
